import * as Sentry from '@sentry/react';

import { EVENT_NAMES } from 'constants/event';
import { DataLayerItem, SendEventProps } from 'types/event';
import { HandledError } from 'utils/handledError';
import { isMobileAgent } from 'utils/isMobileAgent';
import { isIos } from 'utils/platform';
import { delphoiData } from 'types/send';

export function sendError(
  error: string | HandledError | Error | unknown,
  breadcrumb?: string
): void {
  if (isMobileAgent()) {
    const errorObj =
      typeof error === 'string' ? new HandledError(error) : error;

    breadcrumb && Sentry.addBreadcrumb({ message: breadcrumb });

    Sentry.captureException(errorObj);
  }
}

export const sendEvent = {
  error: (): void =>
    pushToDataLayer({
      event_action: 'error',
    }),
  close: (): void =>
    pushToDataLayer({
      event_action: 'close',
    }),
  init: (props: SendEventProps<'init'>): void =>
    pushToDataLayer({
      event_category: props.productGroup,
      event_action: 'init',
      event_label: props.seller,
    }),
  purchase: (): void =>
    pushToDataLayer({
      event_action: 'purchase',
    }),
  custom: (props: DataLayerItem): void => pushToDataLayer(props),
};

function pushToDataLayer(eventProps: DataLayerItem): void {
  const previousDataLayerItem = getPreviousFromDataLayer();
  const item = {
    event: EVENT_NAMES.GA,
    event_category:
      eventProps.event_category?.toLowerCase() ||
      previousDataLayerItem?.event_category,
    event_action: eventProps.event_action?.toLowerCase(),
    event_label: (
      eventProps.event_label ||
      previousDataLayerItem?.event_label ||
      'unknown'
    ).toLowerCase(),
  };

  window.dataLayer?.push(item);
}

function getPreviousFromDataLayer(): DataLayerItem | undefined {
  return (
    (window.dataLayer &&
      window.dataLayer
        .filter((item) => item.event === EVENT_NAMES.GA)
        .slice(-1)[0]) ||
    {}
  );
}

export function sendEventToDelphoi(
  data: delphoiData<Record<string, string>>
): void {
  const { _gcol } = window;
  if (!_gcol) {
    return;
  }
  _gcol.channel = isIos() ? 'iphone' : 'android';
  _gcol.Fire(data.event, data);
}
